// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import useTrackLink from "@store/Framework/GoogleAnalytics/hooks/useTrackLink";
import submitRequestOrderChange from "@store/Framework/Store/Greif/Pages/RequestOrderChange/Handler/SubmitRequestOrderChange";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: RequestOrderChangeButtonStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    changeRequestOrderState: state.greif.pages.orderChange,
});

const mapDispatchToProps = {
    submitRequestOrderChange,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestOrderChangeButtonStyles {
    sendButton?: ButtonPresentationProps;
    wrapper?: InjectableCss;
}

export const requestOrderChangeButton: RequestOrderChangeButtonStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
};

const styles = requestOrderChangeButton;

const ReviewRequestOrderChangeButton = ({ changeRequestOrderState, submitRequestOrderChange }: Props) => {
    const { changeRequestOrder, failedToSubmitRequest, isSubmitting } = changeRequestOrderState;
    const { value: order } = useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    const submitRequestHandler = () => {
        submitRequestOrderChange(changeRequestOrder as any);
        sessionStorage.removeItem(changeRequestOrder.orderId);
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Button
                {...styles.sendButton}
                data-test-selector="requestOrderChangeHeader_send"
                onClick={submitRequestHandler}
                disabled={isSubmitting || failedToSubmitRequest}
            >
                {translate("Send Change Request")}
            </Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ReviewRequestOrderChangeButton),
    definition: {
        allowedContexts: ["ReviewOrderChangeRequestPage" as any],
        group: constants.widgetGroup.reviewOrderChangeRequest,
        displayName: "Review Change Request Buttons",
    },
};

export default widgetModule;
